import React from 'react';

import { useAuthNavigator } from '../../hooks/Auth/useAuthNavigator';

/**
 * Componente que escucha eventos de autenticación y maneja la navegación.
 * Debe montarse dentro de IonReactRouter para tener acceso al router.
 */
const AuthNavigator: React.FC = () => {
  useAuthNavigator();
  return null;
};

export default AuthNavigator;
